import { EntityForm } from '@/common/entityFramework/entityForm/EntityForm';
import { EntityDetail } from '@/common/entityFramework/entityDetail/EntityDetail';
import { useEntityMgr } from '@/common/entityFramework/entityView/EntityMgrContext';
import { useMemo } from 'react';
import { Ndc9ProdForm } from './Ndc9ProdForm';
import { Ndc11ProdList } from '@/md/entities/ndc11Prod/Ndc11ProdList';

export const Ndc9ProdDetail = () => {

  const { entityObj } = useEntityMgr();

  const tabSpecs = useMemo(() => {
    return [
      { id: 'info', label: 'Info', content: <Ndc9ProdForm /> },
      { id: 'labeler', label: 'Labeler', content: <EntityForm module="md" entity="LABELER" entityId={entityObj.labelerId} /> },
      { id: 'ndc11prods', label: 'NDC11s', content: <Ndc11ProdList ndc9ProdId={entityObj.id} /> }

    ]
  }, [entityObj])

  return (
    <EntityDetail tabSpecs={tabSpecs} />
  )

}